var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountlogin = function SvgAccountlogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.997 12H14M11 8.999 14 12l-3 3.001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.998 9.136V7.398a2 2 0 0 1 1.608-1.96L18.611 3.03a2.147 2.147 0 0 1 2.393 2.167v13.806a2.001 2.001 0 0 1-2.34 1.973L7.659 19.083a2 2 0 0 1-1.661-1.973v-2.138"
  })));
};
export { SvgAccountlogin as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMmNhMTY4Mjg1N2I5YzAzNzQwMGMyZmZjNjM1NjJjYTMuc3ZnIjs=";